<template>
  <div class="permission-denied" role="status">
    <div class="permission-denied__head">
      <q-icon name="lock" size="14px" />
      <span>Permission required</span>
    </div>
    <p v-if="reason" class="permission-denied__reason">{{ reason }}</p>
    <p v-if="alternative" class="permission-denied__alt">
      <span class="permission-denied__alt-label">Suggested:</span>
      {{ alternative }}
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  reason?: string;
  alternative?: string;
}>();
</script>

<style scoped lang="scss">
.permission-denied {
  margin: 6px 0;
  padding: 10px 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  color: #9a3412;
  font-size: 13px;

  &__head {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
  }

  &__reason {
    margin: 6px 0 0;
    color: #7c2d12;
    line-height: 1.45;
  }

  &__alt {
    margin: 8px 0 0;
    padding: 8px 10px;
    background: #ffffff;
    border-radius: 8px;
    color: #1f2937;
    line-height: 1.45;
  }

  &__alt-label {
    font-weight: 600;
    color: #3b6cf3;
    margin-right: 4px;
  }
}
</style>
